import styled from 'styled-components';

export const StyledScrollPointer = styled.div`
  animation: rotate 5.0s linear infinite; 
  width: ${({ radius }) => (radius * 2)}px;
  height: ${({ radius }) => (radius * 2)}px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  border-radius: 50%;

  .circle {
    color: ${({ color }) => color};
    background: transparent;
    position: relative;
    border-radius: 50%;
    margin-left: ${({ radius }) => (radius/2)}px;
  }

  .anchor {
    width: ${({ radius }) => (radius/2)}px;
    height: ${({ radius }) => (radius/2)}px;
  }

  @keyframes rotate {
    to { transform: rotate(360deg); }
  }
}
`;

